// SimplyRefer brand mark — the official navy app-icon (two-node "S" referral path).
const SIZES = {
  sm: "h-7 w-7",
  md: "h-8 w-8",
  lg: "h-10 w-10",
};

export const SRMark = ({ size = "md", className = "" }) => (
  <img
    src="/appicon.png"
    alt="SimplyRefer"
    className={`inline-block shrink-0 object-contain ${SIZES[size] || SIZES.md} ${className}`}
  />
);
